<template>
  <v-card width="100%" class="card">
    <v-card-title>Competencias desarrolladas por facultades</v-card-title>
    <v-card-text class="pa-2">
      <v-select
        v-model="facultadSelec"
        :items="headers"
        multiple
        label="Facultad Seleccionada"
        @change="getDataxFacultad"
      ></v-select>
      <RadarChart
        :chart-data="data"
        :options="options"
        :width="20"
        :height="10"
      ></RadarChart>
    </v-card-text>
  </v-card>
</template>

<script>
import RadarChart from '@/components/generic/RadarChart'

export default {
  components: {
    RadarChart
  },
  data() {
    return {
      headers: [
        'FIIS',
        'FIC',
        'FIEE',
        'FC',
        'FIGMM',
        'FIM',
        'FIQT',
        'ARQUITECTURA',
        'FIP',
        'FIA',
        'FIEECS'
      ],
      labels: [
        'Responsabilidad',
        'Liderazgo',
        'Tolerancia a la Frustración',
        'Trabajo en Equipo',
        'Comunicación Asertiva',
        'Empatía y Solidaridad',
        'Capacidad de Emprendimiento y Creatividad',
        'Capacidad Investigativa y Científica'
      ],
      color: [
        'rgba(235, 64, 52, 0.75)',
        'rgba(87, 194, 66, 0.75)',
        'rgba(64, 58, 181, 0.75)',
        'rgba(177, 181, 60, 0.75)',
        'rgba(182, 39, 214, 0.75)',
        'rgba(230, 121, 25, 0.75)',
        'rgba(51, 204, 145, 0.75)',
        'rgba(21, 116, 194, 0.75)',
        'rgba(191, 168, 190, 0.75)',
        'rgba(12, 247, 240, 0.75)',
        'rgba(142, 171, 143, 0.75)'
      ],
      rawData: [],
      dataset: [],
      facultadSelec: [],
      options: {},
      data: {}
    }
  },

  computed: {
    datasetFiltered: function () {
      let response = []
      if (this.facultadSelec.length) {
        for (let i = 0; i < this.dataset.length; i++) {
          for (let j = 0; j < this.facultadSelec.length; j++) {
            if (this.dataset[i].label == this.facultadSelec[i]) {
              response.push(this.dataset[i])
            }
          }
        }
      } else {
        response = this.dataset
      }
      return response
    },

    headersFiltered: function () {
      if (this.facultadSelec.length) {
        return this.facultadSelec
      } else {
        return this.headers
      }
    }
  },

  methods: {
    createRawData() {
      //Mock data on arrData
      let data = []
      for (let i = 0; i < this.headers.length; i++) {
        data[i] = []
        for (let j = 0; j < this.labels.length; j++) {
          data[i].push(Math.floor(4 + Math.random() * 14))
        }
      }
      this.rawData = data
      console.log('this.rawData', this.rawData)
    },

    getDataxFacultad() {
      let dataset = []
      for (let j = 0; j < this.rawData.length; j++) {
        if (this.facultadSelec.length) {
          if (this.facultadSelec.includes(this.headers[j])) {
            dataset.push({
              label: this.headers[j],
              data: this.rawData[j],
              borderColor: this.color[j],
              backgroundColor: 'rgba(255, 255, 255, 0.1)'
            })
          }
        } else {
          dataset.push({
            label: this.headers[j],
            data: this.rawData[j],
            borderColor: this.color[j],
            backgroundColor: 'rgba(255, 255, 255, 0.1)'
          })
        }
      }

      this.data = {
        labels: this.labels,
        datasets: dataset
      }

      console.log(this.data)
    }
  },

  mounted() {
    this.createRawData()
    this.getDataxFacultad()
  }
}
</script>

<style>
.card {
  border-radius: 3px;
  background-clip: border-box;
  border: 1px solid rgba(0, 0, 0, 0.125);
  box-shadow: 1px 1px 1px 1px rgba(0, 0, 0, 0.21);
  background-color: transparent;
}
</style>
